export default __webpack_public_path__ + "static/media/BCC.7390c2b3.jpg";